import { observable, computed } from 'mobx';
import { currencyGivenPennies } from '../../core/utils';

export default class BgCheckPackage {
  @observable name: string = null;
  @observable price: number = null;
  @observable slug: string = null;
  @observable screenings: string[] = [];

  @computed
  get priceAsCurrency() {
    return currencyGivenPennies(this.price);
  }
}
